import { Component, Host, h, Prop, Element } from '@stencil/core';
import { Consumes } from '../context/consumer/consumes-decorator';

export type TagContext = string | { tag: string; attributes?: { [attributes: string]: any } };

@Component({
  tag: 'sy-loading',
  styleUrls: ['scss/index.scss', 'scss/_tokens.scss'],
  shadow: true,
})
export class Loading {
  private tagName: string;
  private attributes = {};

  @Element() el;

  /**
   * Defines which component tag will be rendered.
   */
  @Consumes('loadingComponentTag') @Prop({ reflect: true }) loadingComponentTag:
    | TagContext
    | { small: TagContext; medium: TagContext; large: TagContext } = 'sy-orbital-loading';

  /**
   * Defines loading size.
   */
  @Prop({ reflect: true }) size: 'small' | 'medium' | 'large' = 'small';

  componentWillRender() {
    const tagResults = this.getPropertiesTagContext(this.loadingComponentTag);
    this.tagName = tagResults.tagName;
    this.attributes = tagResults.attributes;
  }

  private getPropertiesTagContext(tagContext) {
    if (!tagContext) {
      return {
        tagName: 'sy-orbital-loading',
        attributes: {},
      };
    }

    if (typeof this.loadingComponentTag === 'string') {
      return {
        tagName: tagContext,
        attributes: {},
      };
    }

    if (tagContext.tag) {
      return {
        tagName: tagContext.tag,
        attributes: tagContext.attributes,
      };
    }

    if (tagContext[this.size]) {
      return this.getPropertiesTagContext(tagContext[this.size]);
    }

    return {
      tagName: 'sy-orbital-loading',
      attributes: {},
    };
  }

  render() {
    return (
      <Host>
        <this.tagName size={this.size} {...this.attributes}></this.tagName>
      </Host>
    );
  }
}
